import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import { AgendaContext } from '../../contexts/AgendaContext';
// Mui components
import { Box, Typography, Button, Tooltip } from '@mui/material';
// Components
import ChipEstadoSolicitud from '../Home/SolicitudCard/ChipEstadoSolicitud';
// Icons
import IconClock from '../../utils/images/icon_clock.svg';

export default function Consultorio({ consultorio, isLast }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const { consultorioOsde, status } = consultorio;

  const { solicitudesPrestador, dispatch } = useContext(AgendaContext);

  const truncatedDireccionOsde =
    consultorioOsde[0]?.direccion.length > 52
      ? `${consultorioOsde[0]?.direccion.substring(0, 52)}...`
      : consultorioOsde[0]?.direccion;

  const solicitudesModificacion = solicitudesPrestador.find(
    (solicitud) =>
      solicitud.tipoSolicitud === 'MODIFICAR_CONSULTORIO' &&
      solicitud.consultorioOsde === consultorioOsde[0].consultorioId &&
      solicitud.status === 'PENDIENTE'
  );

  const handleOpenDetailConsultorio = () => {
    dispatch({ type: 'GET_CONSULTORIO_DETAIL', payload: consultorio });
    navigate(`/prestador/misConsultorios/${consultorioOsde[0]?.consultorioId}`);
  };

  return (
    <Box
      sx={{
        borderBottom: isLast ? 'none' : `2px solid ${theme.palette.backgroundSecondary.main}`,
        display: 'flex',
        padding: '1rem 1.5rem',
        height: '63px'
      }}>
      <Tooltip title={consultorioOsde[0]?.direccion} placement="top">
        <Typography sx={{ width: '420px' }} variant="bodyM">
          {truncatedDireccionOsde}
        </Typography>
      </Tooltip>

      <Box sx={{ display: 'flex', width: '450px', justifyContent: 'space-between' }}>
        <Box sx={{ width: 'fit-content' }}>
          {status === 'INTEROPERANDO' ? (
            <ChipEstadoSolicitud
              backGroundColor={theme.palette.successBackground.main}
              text="Conectado"
              colorText={theme.palette.successSecondary.main}
            />
          ) : status === 'PENDIENTE' ? (
            <ChipEstadoSolicitud
              backGroundColor={theme.palette.backgroundSecondary.main}
              text="Conexión solicitada"
              colorText={theme.palette.primary.main}
            />
          ) : status === 'BAJA' ? (
            <ChipEstadoSolicitud
              backGroundColor={theme.palette.graySuperLight.main}
              text="Desconectado"
              colorText={theme.palette.black.main}
            />
          ) : null}
        </Box>

        <Box sx={{ display: 'flex', width: '185px' }}>
          {solicitudesModificacion && (
            <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
              <Box
                component="img"
                sx={{ width: '16px', height: '16px' }}
                alt="img not found"
                src={IconClock}
              />
              <Typography variant="bodyS">Modificaciones solicitadas</Typography>
            </Box>
          )}
        </Box>

        <Button
          variant="text"
          onClick={handleOpenDetailConsultorio}
          disableRipple
          sx={{
            padding: '0',
            color: theme.palette.primary.main,
            display: 'flex',
            '&:hover': {
              backgroundColor: 'transparent'
            }
          }}>
          <Typography variant="textLink" sx={{ textDecoration: 'underline' }}>
            Ver detalle
          </Typography>
        </Button>
      </Box>
    </Box>
  );
}
